import { SelectedDateTime } from '@illegally-parked/store/storeSlices/issueDetails';

export const getDateTimeString = (selectedDateTime: SelectedDateTime) => {
  const {
    selectedDay,
    selectedMonth,
    selectedYear,
    selectedHour,
    selectedMinute,
  } = selectedDateTime;

  if (
    selectedDay &&
    selectedMonth &&
    selectedYear &&
    selectedHour &&
    selectedMinute
  ) {
    // convert to ISO string to handle daylight savings changes
    return new Date(
      Number(selectedYear),
      Number(selectedMonth) - 1,
      Number(selectedDay),
      Number(selectedHour),
      Number(selectedMinute),
    ).toISOString();
  }
  return '';
};
